import { Record } from "immutable";
import { InstructorApplicationStatus } from "models/enumerations/aen-applications/instructor-application-status";
import { PatchInstructorApplication } from "models/interfaces/aen-applications/patch-instructor-application";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: PatchInstructorApplication = {
    id: 0,
    status: InstructorApplicationStatus.Submitted,
    assignedToId: undefined,
    reasonForChange: "",
    sendMessage: false,
    messageSubject: "",
    messageBody: "",
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class PatchInstructorApplicationRecord
    extends Record(defaultValues)
    implements PatchInstructorApplication
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<PatchInstructorApplication>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    public with(values: Partial<PatchInstructorApplication>): PatchInstructorApplicationRecord {
        return new PatchInstructorApplicationRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// #endregion Record

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { PatchInstructorApplicationRecord };

// #endregion Exports
